import styeld from "styled-components";

export const MainWrapper = styeld.div`
width:100%;
background-color: #f2f2f2;
padding-bottom:50px;
`;
